import React from "react";
import "./Frites.css";
import videoFrites from "../asset/video/logoAnime.mp4";

const Frites = () => {
  return (
    <section className="frites" id="a_propos">
      <div className="frites-overlay">
        <div className="frites-container">
          <div className="frites-text">
            <h2>À propos de <span>ma friterie</span></h2>
            <p>
              Bienvenue chez <strong>Les Tontons Friteurs</strong>, où la convivialité rime avec gourmandise ! <br /><br />
              Je suis <strong>Mélanie</strong>, passionnée par la bonne humeur et la bonne cuisine depuis toujours. <br /><br />
              Depuis <strong>2006</strong>, je régale <strong>particuliers</strong> et <strong>professionnels</strong> lors de tous types d’événements :  
              <em> mariages, anniversaires, fêtes d’entreprise, réunions familiales, braderies</em> et bien plus encore ! <br /><br />
              <span className="accent">Mon objectif ?</span>  
              Proposer une expérience <strong>conviviale et savoureuse</strong>, où la qualité des produits se marie à un service attentionné.
            </p>
          </div>

          <div className="frites-video">
            <video className="videoFrites" autoPlay muted loop playsInline>
              <source src={videoFrites} type="video/mp4" />
              Ton navigateur ne supporte pas la vidéo.
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Frites;
